import { APP_SETTINGS } from './Base';

export const onSetRequest = (params = {}, cb) => ({ params, type: APP_SETTINGS.SET_REQUEST, cb });
export const onSetSelectedHitClubRequest = (params = {}, cb) => ({ params, type: APP_SETTINGS.SET_SELECTED_HITCLUB_REQUEST, cb });

export const onResetRequest = (payload = {}) => ({ payload, type: APP_SETTINGS.RESET_REQUEST });
